module.exports = __webpack_public_path__ + "img/ksjs.17f5ad5b.jpg";